/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Academy_EmptyInputs */

const en_academy_empty = /** @type {(inputs: Academy_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No courses assigned`)
};

const ja_academy_empty = /** @type {(inputs: Academy_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コースが割り当てられていません`)
};

const fr_academy_empty = /** @type {(inputs: Academy_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun cours assigné`)
};

const de_academy_empty = /** @type {(inputs: Academy_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Kurse zugewiesen`)
};

/**
* | output |
* | --- |
* | "No courses assigned" |
*
* @param {Academy_EmptyInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const academy_empty = /** @type {((inputs?: Academy_EmptyInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Academy_EmptyInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_academy_empty(inputs)
	if (locale === "ja") return ja_academy_empty(inputs)
	if (locale === "fr") return fr_academy_empty(inputs)
	return de_academy_empty(inputs)
});